import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  const styleObj = {
    verticalAlign: "middle",
  };
  return (
    <div>
      <table>
        <thead>
          <th></th>
          <th>zoomback for the People</th>
          <th>zoomback for Freelancers</th>
          <th>zoomback for Businesses</th>
        </thead>
        <tbody>
          <tr>
            <td>Watermark-free</td>
            <td><i class="fas fa-times"></i></td>
            <td><i class="fas fa-check"></i></td>
            <td><i class="fas fa-check"></i></td>
          </tr>
          <tr>
            <td>Shareable template</td>
            <td><i class="fas fa-times"></i></td>
            <td><i class="fas fa-times"></i></td>
            <td><i class="fas fa-check"></i></td>
          </tr>
          <tr>
            <td>But why</td>
            <td>To spread goodwill, allowing more people and businesses to discover and benefit from zoomback.</td>
            <td>A professional option for a remote working professional. The only logo within sight is your own.</td>
            <td>Brand image is important. This is a scalable solution that equips your representatives on zoom, easily.</td>
          </tr>
          <tr>
            <td>Dummy-proof instructions</td>
            <td>Fill in your details, adjust the colors,<br />and then click:<br /><br />Export Design</td>
            <td>Same. But you should "Toggle Watermark", and then click:<br /><br />Export Design</td>
            <td>Same. But you should "Toggle Watermark", and then click:<br /><br />Create Shareable Template</td>
          </tr>
          <tr>
            <td>What does the button do?</td>
            <td>Triggers the virtual background<br />to download to your computer.<br /><br />Automagically.</td>
            <td>Triggers the virtual background<br />to download to your computer.<br /><br />Automagically.</td>
            <td>You'll be redirected to a shareable template. Share it with infinite colleagues, who'll simply fill in their details and then export.</td>
          </tr>
          <tr>
            <td>Price</td>
            <td>Free</td>
            <td>Free</td>
            <td>Free</td>
          </tr>
        </tbody>
      </table>
      <br /><br />
      <p>
          I design, code, and make things. That's what I do. In addition to staying at home<br />
          and practicing social distancing (programmers are already experts at this, but that's another story),<br />
          I wanted to somehow contribute towards helping society get through these strange times.<br />
          Hopefully, some people will find zoomback useful.
      </p>
      <br />
      <Link to="/create">
        Create your zoomback <i style={styleObj} class="fas fa-arrow-right"></i>
      </Link>
    </div>
  );
};

export default About;
